import "./_style.less";
import { Schedule } from "../../../../models/Schedule";
import clsx from "clsx";
import moment from "moment";

interface IScheduleChip {
  onClick: (schedule: Schedule) => void;
  value: Schedule;
  isSelected?: boolean;
  disabled?: boolean;
}

const ScheduleChip = ({ onClick, isSelected, value, disabled }: IScheduleChip) => {
  return (
    <div
      onClick={() => {
        if (!disabled) onClick(value);
      }}
      className={clsx("schedule-chip", {
        selected: isSelected,
        disabled: disabled,
      })}
      style={disabled ? { pointerEvents: 'none', opacity: 0.5 } : {}}
    >
      {moment(value?.date).format("ddd, DD MMM")}
    </div>
  );
};

export default ScheduleChip;
